<template>
  <el-dialog
    v-drag
    :title="editData.code || callType === 'pass' ? '修改' : '新增'"
    :visible.sync="dialogVisible"
    width="1160px"
    top="1%"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <el-form ref="form" class="form" :model="companyData" :rules="rules">
        <el-row class="row">
          <div class="panel">
            <!-- <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>客户编码</label>
              <el-form-item prop="identityCode">
                <el-input
                  v-model="companyData.identityCode"
                  :disabled="!!editData.id"
                  placeholder="请输入客户编码"
                ></el-input>
              </el-form-item>
            </div> -->
            <div class="form-item w-420">
              <label class="lable"><span class="red">* </span>中文名称</label>
              <el-form-item prop="nameCH">
                <el-input
                  v-model="companyData.nameCH"
                  placeholder="请输入中文名"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item w-420">
              <label class="lable"><span class="red">* </span>英文名称</label>
              <el-form-item prop="nameEN">
                <el-input
                  v-model="companyData.nameEN"
                  placeholder="请输入英文名"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-row>
        <el-row>
          <div class="panel">
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>地址</label>
              <el-form-item prop="address">
                <el-cascader
                  v-model="companyData.address"
                  :options="addressDropOption"
                  placeholder="请选择地址"
                  style="width: 100%"
                  :props="{
                    expandTrigger: 'click',
                    value: 'value',
                    label: 'label',
                    children: 'children',
                  }"
                ></el-cascader>
              </el-form-item>
            </div>
            <div class="form-item w-420">
              <label class="lable"><span class="red">* </span>详细地址</label>
              <el-form-item prop="addressDetail">
                <el-input
                  v-model="companyData.addressDetail"
                  placeholder="请输入详细地址"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>代码</label>
              <el-form-item prop="code">
                <el-input
                  v-model="companyData.code"
                  placeholder="请输入代码(四-五位唯一)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>简称</label>
              <el-form-item prop="wbName">
                <el-input
                  v-model="companyData.wbName"
                  placeholder="请输入简称"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-row>
        <el-row>
          <div class="panel">
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>状态</label>
              <el-form-item prop="isActived">
                <el-select v-model="companyData.isActived" placeholder="请选择">
                  <el-option
                    v-for="item in activeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>销售员</label>
              <el-form-item prop="saleId">
                <el-select
                  v-model="companyData.saleId"
                  placeholder="请选择销售员"
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>预警邮箱</label>
              <el-form-item prop="noticeEmail">
                <el-input
                  v-model="companyData.noticeEmail"
                  placeholder="请输入预警邮箱"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>结算币种</label>
              <el-form-item prop="currency">
                <el-select
                  v-model="companyData.currency"
                  placeholder="请选择"
                  :disabled="!!editData.code"
                >
                  <el-option
                    v-for="item in currencyData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-item w-200">
              <label class="lable"><span class="red">* </span>签订合同</label>
              <el-form-item prop="bussinessFlag">
                <el-select
                  v-model="companyData.bussinessFlag"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in bussinessFlagOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-row>
        <el-row>
          <div class="panel">
            <div class="form-item w-420">
              <label class="lable">备注</label>
              <el-form-item prop="remark">
                <el-input
                  v-model="companyData.remark"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item w-200">
              <label class="lable">法人</label>
              <el-form-item prop="legalMan">
                <el-input
                  v-model="companyData.legalMan"
                  placeholder="请输入法人"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item w-420">
              <label class="lable"><span class="red">* </span>合同期限</label>
              <el-form-item prop="remark">
                <BaseDateCommon
                  v-model="companyData.contractDate"
                  width="420"
                ></BaseDateCommon>
              </el-form-item>
            </div>
          </div>
        </el-row>
        <el-row>
          <div class="panel" style="justify-content: start">
            <div class="form-item w-200">
              <label class="lable">关键客户</label>
              <el-form-item prop="isCritical">
                <el-switch
                  v-model="companyData.isCritical"
                  :active-text="companyData.isCritical ? '是' : '否'"
                >
                </el-switch>
              </el-form-item>
            </div>
            <div class="form-item w-420">
              <label
                class="lable"
              ><span class="red">* </span>营业执照图片</label
              >
              <el-form-item prop="certificateFileId" style="min-width: 240px">
                <img
                  v-if="companyData.certificateFileId"
                  :src="companyData.certificateFileUrl"
                  class="license-preview"
                />
                <el-upload
                  v-else
                  class="upload-demo"
                  accept=".png,.PNG,.JPG,jpg,jpeg,.JPEG"
                  :limit="1"
                  :action="`/api/SystemFile/uploadFile?source=10`"
                  :data="{ source: 10 }"
                  :headers="headers"
                  :file-list="fileList"
                  :show-file-list="false"
                  :on-success="onSuccess"
                  :on-error="onError"
                >
                  <div class="license-upload">
                    <span class="plus-icon">+</span>
                  </div>
                </el-upload>
              </el-form-item>
            </div>
          </div>
        </el-row>
      </el-form>
      <div class="tab">
        <div class="line"></div>
        <BaseTab
          style="z-index: 1"
          :tabItems="tabItems"
          :propWidth="490"
          :active="active"
          @tabChange="tabChange"
        ></BaseTab>
      </div>
      <div v-show="active !== 2" class="add-item-content">
        <div class="add-item" @click="add">
          <i class="el-icon-circle-plus-outline" />
          添加
        </div>
      </div>
      <div class="baseTable">
        <ul v-show="active === 0">
          <li class="header">
            <div class="cell"><span class="red">* </span>中文名</div>
            <div class="cell">英文名</div>
            <div class="cell"><span class="red">* </span>联系人类型</div>
            <div class="cell"><span class="red">* </span>手机</div>
            <div class="cell"><span class="red">* </span>邮箱</div>
            <div class="cell">固定电话</div>
            <div class="cell">操作</div>
          </li>
        </ul>
        <ul v-show="active === 0" class="tableBody">
          <template v-for="(item, $index) in contactList">
            <template>
              <li :key="$index" class="row">
                <div class="cell" :title="item.nameCH">{{ item.nameCH }}</div>
                <div class="cell" :title="item.nameEN">{{ item.nameEN }}</div>
                <div class="cell">{{ item.type | formatterType }}</div>
                <div class="cell" :title="item.phone">{{ item.phone }}</div>
                <div class="cell" :title="item.email">{{ item.email }}</div>
                <div class="cell" :title="item.tel">{{ item.tel }}</div>
                <div class="cell">
                  <i
                    class="el-icon-edit"
                    title="修改"
                    @click="updateContactList($index)"
                  />
                  <i
                    class="el-icon-delete"
                    style="margin-left: 32px"
                    title="删除"
                    @click="removeContactList($index)"
                  />
                </div>
              </li>
            </template>
          </template>
        </ul>
        <ul v-show="active === 1">
          <li class="header">
            <div class="cell1"><span class="red">* </span>跟进人类型</div>
            <div class="cell1"><span class="red">* </span>用户</div>
            <div class="cell1"><span class="red">* </span>中文名</div>
          </li>
        </ul>
        <ul v-show="active === 1" class="tableBody">
          <template v-for="(item, $index) in followUpsList">
            <template>
              <li :key="$index" class="row">
                <div class="cell1">{{ item.type | formatterType }}</div>
                <div class="cell1">{{ item.nameCH }}</div>
                <div class="cell1">
                  <i
                    class="el-icon-delete"
                    title="删除"
                    @click="removeFollowUpsList($index)"
                  />
                </div>
              </li>
            </template>
          </template>
        </ul>
        <ul v-show="active === 2">
          <li class="header">
            <div class="cell2">用户名</div>
            <div class="cell2">角色</div>
            <div class="cell2">电话</div>
            <div class="cell2">操作更新人</div>
            <div class="cell2">操作</div>
          </li>
        </ul>
        <ul v-show="active === 2" class="tableBody">
          <template v-for="(item, $index) in companyData.users">
            <template>
              <li :key="$index" class="row">
                <div class="cell2">{{ item.userName }}</div>
                <div class="cell2">{{ item.typeName }}</div>
                <div class="cell2">{{ item.phoneNumber }}</div>
                <div class="cell2">{{ item.updatedName }}</div>
                <div class="cell2">
                  <el-switch
                    v-model="item.isActived"
                    :active-text="item.isActived ? '启用' : '停用'"
                    @change="userSwitch(item)"
                  >
                  </el-switch>
                </div>
              </li>
            </template>
          </template>
        </ul>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel" @click="cancel">取 消</div>
      <div v-loading="loading" class="ok" @click="ok('form')">确 定</div>
    </span>
    <add-follow-ups-dialog
      :dialogVisible="dialogVisible2"
      @ok="ok2"
      @cancel="cancel2"
    ></add-follow-ups-dialog>
    <add-contact-dialog
      :dialogVisible="dialogVisible1"
      :editRow="editRow"
      @ok="ok1"
      @cancel="cancel1"
    ></add-contact-dialog>
  </el-dialog>
</template>
<script>
const BaseTab = () => import('@/components/tab/BaseTab')
const BaseDateCommon = () => import('@/components/base/BaseDateCommon.vue')
import { mapGetters } from 'vuex'
import AddContactDialog from './AddContactDialog.vue'
import AddFollowUpsDialog from './AddFollowUpsDialog.vue'
// import {
//   getSysParams,
//   addCompany,
//   updateCompany,
//   ChangeUserStatus
// } from '@/api/system'

import {
  getSysParams,
  passCompany,
  operationCompany,
  ChangeUserStatus
} from '@/api/setting'
import { createSubCompany, getCompanyDetail } from '@/api/system'
import { isValidEmail } from '@/utils/validate'
import config from '@/utils/config'
export default {
  components: {
    AddContactDialog,
    AddFollowUpsDialog,
    BaseDateCommon,
    BaseTab
  },
  filters: {
    formatterType(val) {
      let str = ''
      switch (val) {
        case 0:
          str = '操作'
          break
        case 1:
          str = '财务'
          break
        case 2:
          str = '客服'
          break
        case 3:
          str = '负责人'
          break
        case 4:
          str = '公司信息'
          break
      }
      return str
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    updateData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    userOptions: {
      type: Array,
      default: function() {
        return []
      }
    },
    callType: {
      type: String,
      default: 'operation' // 'operation' 或 'pass'
    },
    companyApplyRecordId: {
      type: Number,
      default: 0
    },
    subCompanyId: {
      type: Number,
      default: 0
    }
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!isValidEmail(value)) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (value.length !== 4 && value.length !== 5) {
        callback(new Error('请输入4、5字代码'))
      } else {
        callback()
      }
    }
    return {
      form: {},
      headers: {
        ESCLEARANCE: btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`)
      },
      config,
      fileList: [],
      rules: {
        nameCH: [
          { required: true, message: '请输入中文名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { validator: validateCode, trigger: 'blur' }
        ],
        wbName: [{ required: true, message: '请输入简称', trigger: 'blur' }],
        isActived: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        noticeEmail: [
          { required: true, message: '请输入通知邮箱', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        saleId: [
          { required: true, message: '请选择销售', trigger: 'change' }
        ],
        currency: [
          { required: true, message: '请选择结算币种', trigger: 'change' }
        ],
        bussinessFlag: [
          { required: true, message: '请选择是否签订合同', trigger: 'change' }
        ],
        address: [{ required: true, message: '请选择地址', trigger: 'change' }], // 修复：添加地址验证
        addressDetail: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ], // 修复：添加详细地址验证
        certificateFileId: [
          { required: true, message: '请上传营业执照', trigger: 'change' }
        ]
      },
      companyData: {},
      activeOptions: [
        {
          value: true,
          label: '在用'
        },
        {
          value: false,
          label: '停用'
        }
      ],
      bussinessFlagOptions: [
        {
          value: true,
          label: '已签'
        },
        {
          value: false,
          label: '未签'
        }
      ],
      // tabItems: [
      //   {
      //     id: 0,
      //     name: '联系方式列表'
      //   },
      //   {
      //     id: 1,
      //     name: '跟进人列表'
      //   },
      //   {
      //     id: 2,
      //     name: '员工列表'
      //   }
      // ],
      active: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      loading: false,
      contactList: [],
      followUpsList: [],
      currencyData: [],
      editRow: {}
    }
  },
  computed: {
    ...mapGetters(['addressDropOption']),
    tabItems() {
      if (this.updateData.id) {
        return [
          {
            id: 0,
            name: '联系方式列表'
          },
          {
            id: 1,
            name: '跟进人列表'
          }
          // {
          //   id: 2,
          //   name: '员工列表'
          // }
        ]
      } else {
        return [
          {
            id: 0,
            name: '联系方式列表'
          },
          {
            id: 1,
            name: '跟进人列表'
          }
        ]
      }
    }
  },
  watch: {
    dialogVisible: function(val) {
      if (val) {
        this.initFormData()
        this.loading = false
      }
    }
  },
  created() {
    this.getCommData()
    if (!this.addressDropOption) {
      this.$store.dispatch('getAddress')
    }
  },
  methods: {
    // 修复：初始化表单数据
    async initFormData() {
      if (this.editData.id || this.editData.companyApplyRecordId) {
        const res = await getCompanyDetail({
          companyId: this.editData.id || this.editData.companyApplyRecordId
        })
        if (!res.success) {
          this.$message.error(res.errorMessage)
          return
        }
        const { followUps, contacts } = res.data
        // 编辑状态 - 回显数据
        this.companyData = {
          ...this.editData,
          // certificateFileId: this.editData.certificateFileId,
          // certificateFileUrl: this.editData.certificateFileUrl,
          nameCH: this.editData.nameCH || this.editData.companyName,
          address: [
            this.editData.countryId,
            this.editData.provinceId,
            this.editData.cityId
          ],
          contractDate: [
            this.editData.bussinessStartDate,
            this.editData.bussinessEndDate
          ],
          addressDetail: this.editData.address || ''
        }
        this.contactList = contacts
        this.followUpsList = followUps
      } else {
        // 新增状态 - 清空数据
        this.companyData = {
          nameCH: this.editData.nameCH || '',
          nameEN: '',
          code: '',
          wbName: '',
          isActived: true,
          saleId: '',
          noticeEmail: '',
          currency: '',
          bussinessFlag: true,
          isCritical: false,
          remark: '',
          certificateFileId: '',
          address: [],
          contractDate: [],
          addressDetail: '',
          legalMan: ''
        }
           this.contactList = []
        this.followUpsList = []
      }
    },
    tabChange(type) {
      this.active = type.id
    },
    cancel() {
      this.active = 0
      this.$emit('cancel')
      this.$refs['form'].resetFields()
    },
    ok(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let flag = false
          const arr = this.followUpsList.map((item) => {
            return item.type
          })
          const optArr = [0, 1, 2]
          optArr.forEach((a) => {
            if (arr.indexOf(a) === -1) {
              flag = true
            }
          })
          if (flag) {
            this.$message.warning('跟进人类型不完整或未填写')
            return false
          }
          if (this.companyData.contractDate.length !== 2 || !this.companyData.contractDate[0] || !this.companyData.contractDate[1]) {
            this.$message.warning('未填写合同日期')
            return false
          }
          this.loading = true
          const submitData = {
            ...this.companyData,
            nameCH: this.companyData.nameCH,
            nameEN: this.companyData.nameEN,
            code: this.companyData.code,
            wbName: this.companyData.wbName,
            noticeEmail: this.companyData.noticeEmail,
            currency: this.companyData.currency,
            countryId: this.companyData.address[0],
            provinceId: this.companyData.address[1],
            cityId: this.companyData.address[2],
            address: this.companyData.addressDetail,
            addressDetail: undefined,
            id: this.editData.id || undefined,
            isActived: this.companyData.isActived,
            bussinessFlag: this.companyData.bussinessFlag,
            certificateFileId: this.companyData.certificateFileId,
            saleId: this.companyData.saleId,
            remark: this.companyData.remark,
            legalMan: this.companyData.legalMan,
            bussinessEndDate: this.companyData.contractDate[1],
            bussinessStartDate: this.companyData.contractDate[0],
            followUps: [...this.followUpsList],
            contacts: [...this.contactList]
          }

          // 根据调用类型选择不同的接口
          if (this.callType === 'pass') {
            // 调用 passCompany 接口（审核通过，补充客户资料）
            // 注意：passCompany 接口内部会处理新增公司的逻辑
            passCompany({
              companyApplyRecordId:
                this.companyApplyRecordId ||
                this.editData.companyApplyRecordId ||
                0,
              id: this.editData.id || null,
              isCritical: this.companyData.isCritical || false,
              code: this.companyData.code,
              nameCH: this.companyData.nameCH,
              nameEN: this.companyData.nameEN || '',
              wbName: this.companyData.wbName,
              currency: this.companyData.currency,
              bussinessFlag: this.companyData.bussinessFlag,
              noticeEmail: this.companyData.noticeEmail,
              certificateFileId: this.companyData.certificateFileId || null,
              certificateFileUrl: this.companyData.certificateFileUrl || '',
              countryId: this.companyData.address[0] || null,
              provinceId: this.companyData.address[1] || null,
              cityId: this.companyData.address[2] || null,
              address: this.companyData.addressDetail,
              saleId: this.companyData.saleId,
              legalMan: this.companyData.legalMan || '',
              remark: this.companyData.remark || '',
              isActived: this.companyData.isActived,
              bussinessStartDate: this.companyData.contractDate[0],
              bussinessEndDate: this.companyData.contractDate[1],
              followUps: [...this.followUpsList],
              contacts: [...this.contactList],
              // 这里传待审核列表里的申请人 userId
              userId: this.editData.userId || 0
              // logoFileUrl: '',
              // userGroupId: null,
              // customerServiceId: null,
              // parentCompanyId: null
            })
              .then((res) => {
                this.loading = false
                if (res.success) {
                  this.$message.success(res.errorMessage || '补充资料成功')
                  this.$emit('ok')
                } else {
                  this.$message.error(res.errorMessage || '操作失败')
                }
              })
              .catch((err) => {
                this.loading = false
                console.error(err)
                this.$message.error('操作失败，请重试')
              })
          } else {
            // 调用 operationCompany 接口（新增/修改）
            // operationCompany 根据 id 是否大于0 来判断是新增还是修改
            if (this.subCompanyId) {
              createSubCompany({
                ...submitData,
                id: this.subCompanyId
              })
                .then((res) => {
                  this.loading = false
                  if (res.success) {
                    const message = this.editData.id ? '修改成功' : '新增成功'
                    this.$message.success(res.errorMessage || message)
                    this.$emit('ok')
                  } else {
                    this.$message.error(res.errorMessage || '操作失败')
                  }
                })
                .catch((err) => {
                  this.loading = false
                  console.error(err)
                  this.$message.error('操作失败，请重试')
                })
            } else {
              operationCompany(submitData)
                .then((res) => {
                  this.loading = false
                  if (res.success) {
                    const message = this.editData.id ? '修改成功' : '新增成功'
                    this.$message.success(res.errorMessage || message)
                    this.$emit('ok')
                  } else {
                    this.$message.error(res.errorMessage || '操作失败')
                  }
                })
                .catch((err) => {
                  this.loading = false
                  console.error(err)
                  this.$message.error('操作失败，请重试')
                })
            }
          }
        }
      })
    },
    cancel1() {
      this.editRow = {}
      this.dialogVisible1 = false
    },
    ok1(data) {
      const flagIndex = this.contactList.findIndex((a) => a.id === data.id)
      if (flagIndex === -1) {
        this.contactList.push({
          ...data,
          id: data.id ? data.id : this.contactList.length
        })
      } else {
        this.contactList.splice(flagIndex, 1, {
          ...data
        })
      }
      this.editRow = {}
      this.dialogVisible1 = false
    },
    removeContactList(index) {
      this.contactList.splice(index, 1)
    },
    updateContactList(index) {
      this.editRow = this.contactList[index]
      this.dialogVisible1 = true
    },
    cancel2() {
      this.dialogVisible2 = false
    },
    ok2(data) {
      data.forEach((item, index) => {
        this.followUpsList.push({
          ...item,
          id: this.followUpsList.length + index
        })
      })
      // this.followUpsList.push({
      //   ...data,
      //   id: this.followUpsList.length
      // })
      this.dialogVisible2 = false
    },
    addComm() {
      this.dialogVisible3 = true
    },
    cancel3() {
      this.dialogVisible3 = false
    },
    removeFollowUpsList(index) {
      this.followUpsList.splice(index, 1)
    },
    add() {
      if (this.active === 1) {
        this.dialogVisible2 = true
      } else {
        this.dialogVisible1 = true
      }
    },
    getCommData() {
      getSysParams({ type: 7 }).then((res) => {
        if (res.success) {
          const arr = []
          res.data &&
            res.data[0].value &&
            res.data[0].value.map((item) => {
              arr.push({
                value: item.dbValue,
                label: item.description
              })
            })
          this.currencyData = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    dataChange() {
      this.getCommData()
    },
    onSuccess(res) {
      console.log('res', res)
      if (res.success) {
        this.companyData.certificateFileId = res.data.id
        this.companyData.certificateFileName = res.data.fileName
        this.companyData.certificateFileUrl = res.data.filePath
      }
    },
    onError(res) {
      this.$message.error(res.errorMessage)
    },
    download(id) {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = `/api/SystemFile/downLoadFile?guid=${id}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    async userSwitch(item) {
      try {
        const params = {
          userId: item.userId,
          userName: item.userName,
          enable: item.isActived
        }
        const res = await ChangeUserStatus(params)
        if (res.success) {
          this.$message.success(res.errorMessage)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: calc(100% - 40px);
  height: auto;
  margin: 0 auto;
  text-align: left;
  .panel {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    .add {
      width: 56px;
      height: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      margin-left: 70px;
      cursor: pointer;
    }
  }
  .w-200 {
    width: 200px;
  }
  .w-420 {
    width: 420px;
  }
  .w-300 {
    width: 307px;
  }
  .red {
    color: #ff7444;
  }
  .tab {
    width: 100%;
    height: 40px;
    margin: 30px auto;
    position: relative;
    .line {
      width: 100%;
      height: 1px;
      background: #eeeeee;
      position: absolute;
      top: 19px;
    }
  }
  .add-item-content {
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row-reverse;
  }
  .add-item {
    width: 100px;
    height: 40px;
    background: #35ba83;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .baseTable {
    width: 100%;
    height: 240px;
    border: 1px solid #eeeeee;
    margin-top: 10px;
    border-radius: 4px 4px 4px 4px;
    box-sizing: border-box;
    overflow: hidden;
    ul {
      width: 100%;
    }
    ul li {
      width: 100%;
      height: 40px;
      display: flex;
      text-align: center;
    }
    .header {
      background: #f7f7f7;
      .cell {
        width: 14.286%;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
      }
      .cell1 {
        width: 33.34%;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
      }
      .cell2 {
        width: 25%;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
      }
    }
    .red {
      color: #ff7444;
    }
    .tableBody {
      width: 100%;
      height: 200px;
      overflow: auto;
      .cell {
        width: 14.286%;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .cell1 {
        width: 33.34%;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;

        line-height: 40px;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
      }
      .cell2 {
        width: 25%;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;

        line-height: 40px;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
      }
      .el-icon-delete {
        cursor: pointer;
      }
    }
  }
  .file {
    height: 40px;
    display: flex;
    justify-content: space-between;
    .fileName {
      height: 40px;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 40px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .opt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        cursor: pointer;
      }
    }
  }
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
  }
}
:deep(".el-dialog") {
  margin: 0 auto;
}
.btn {
  width: 200px;
  height: 40px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid rgb(18, 88, 188);
  color: rgb(18, 88, 188);
  img {
    vertical-align: middle;
    margin-top: -5px;
  }
}
// 营业执照上传样式
.license-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.3s;
  overflow: hidden;

  &:hover {
    border-color: rgb(18, 88, 188);
  }
  .plus-icon {
    font-size: 24px;
    color: #999;
  }
}
.license-preview {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
/deep/ .el-form-item__content {
  line-height: 1;
}
/deep/ .input-number-range {
  border: 0;
}
/deep/ .input-number-range input {
  border: 0;
}
</style>
